import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, TrendingUp, Search, Star, Users, Building2, ArrowRight, Crown, ChefHat, BarChart3, Megaphone, ShieldCheck, Mail } from 'lucide-react';
import SEO from '../components/SEO';
import { TEAM_AVATARS } from '../components/teamAvatars';
import { AgentHelp } from '../components/AgentHelp';

const LOCATIONS = [
  { name: 'Port Chester', addr: '139 N Main St, Port Chester, NY' },
  { name: 'White Plains', addr: '179 Martine Ave, White Plains, NY' },
  { name: 'New Rochelle', addr: '237 E Main St, New Rochelle, NY' },
  { name: 'Ossining', addr: '27 Croton Ave, Ossining, NY' },
  { name: 'Hempstead', addr: '140 Front St, Hempstead, NY' },
  { name: 'Norwalk', addr: '45 N Main St, Norwalk, CT' },
];

const T = {
  es: {
    eyebrow: 'Cliente VIP · Bienvenida personalizada',
    star: 'Demo preferida',
    title: 'Bienvenidos, Sr. Jorge Valencia y Sra. Amparo Ramírez',
    sub: 'La familia Makondo: seis restaurantes que unen a la comunidad latina con el mundo a través del sabor colombiano. Nuestro trabajo: que vendan más — hoy, y en cada local que abran mañana.',
    locTitle: 'Sus 6 casas, un solo cerebro de ventas',
    locSub: 'Kitxens une los datos de Port Chester, White Plains, New Rochelle, Ossining, Hempstead y Norwalk en un solo panel: qué se vende, dónde, a qué hora y qué hacer al respecto.',
    whatTitle: '¿Qué hace Kitxens por Makondo?',
    what: [
      { icon: TrendingUp, t: 'Más ventas en los 6 locales', d: 'Panel de ventas en vivo por local, plato y canal (salón, pedidos directos, DoorDash, catering). Detectamos qué empuja el ticket — del pan de bono del fin de semana a la bandeja paisa del almuerzo — y qué hacer cada semana para vender más.' },
      { icon: Search, t: 'Que los encuentren primero', d: 'Cada vez más clientes preguntan a Google y ChatGPT "best Colombian food near me". Optimizamos su visibilidad en búsqueda con IA, Google Business y reseñas para que Makondo aparezca antes que nadie en Westchester.' },
      { icon: Megaphone, t: 'Marketing que se hace solo', d: 'Penny, nuestra directora de marketing IA, prepara campañas, contenido y promociones adaptadas a su cocina y su comunidad. Usted solo aprueba — nada se publica sin su OK.' },
      { icon: Star, t: 'Reputación protegida', d: 'Monitoreamos reseñas en todos los locales, detectamos problemas antes de que escalen y preparamos respuestas que suenan a Makondo, no a un robot.' },
      { icon: Building2, t: 'El 7º local, con datos', d: 'Cuando decidan abrir el próximo restaurante, lo harán sabiendo: qué zona, qué menú, qué precios y qué demanda — con el modelo de sus 6 locales actuales como prueba.' },
      { icon: ShieldCheck, t: 'Acompañamiento VIP', d: 'Línea directa con nuestro equipo. Revisión mensual de resultados, plan de acción claro, y un equipo ejecutivo de IA trabajando para ustedes 24/7.' },
    ],
    teamTitle: 'Su equipo ejecutivo de IA',
    teamSub: 'Seis ejecutivos trabajando para Makondo todos los días. Preparan todo; ustedes deciden.',
    team: [
      { k: 'rachel', n: 'Rachel', r: 'Coordina todo el equipo' },
      { k: 'stan', n: 'Stan', r: 'Analiza sus ventas' },
      { k: 'penny', n: 'Penny', r: 'Crea su marketing' },
      { k: 'sonny', n: 'Sonny', r: 'Distribuye y publica' },
      { k: 'eva', n: 'Eva', r: 'Cuida la operación' },
      { k: 'linda', n: 'Linda', r: 'Mide el impacto financiero' },
    ],
    accessTitle: 'Su acceso al Restaurant AI OS',
    accessSub: 'Su workspace privado ya está listo, con sus ventas, su menú y su equipo de IA. Entre con las credenciales que le enviamos por email.',
    accessEmail: 'Usuario',
    accessPwd: 'Contraseña',
    accessPwdNote: 'enviada por email · info@kitxens.com',
    accessBtn: 'Entrar a mi Restaurant AI OS',
    accessHelp: '¿Dudas? Escríbanos a',
    ctaFoot: 'Un pedacito de Macondo, con el mejor copiloto de ventas.',
  },
  en: {
    eyebrow: 'VIP Client · Personalized welcome',
    star: 'Preferred demo',
    title: 'Welcome, Mr. Jorge Valencia & Mrs. Amparo Ramírez',
    sub: 'The Makondo family: six restaurants uniting the Latino community with the world through Colombian flavor. Our job: help you sell more — today, and in every location you open tomorrow.',
    locTitle: 'Your 6 homes, one sales brain',
    locSub: 'Kitxens unifies Port Chester, White Plains, New Rochelle, Ossining, Hempstead and Norwalk into one panel: what sells, where, at what time — and what to do about it.',
    whatTitle: 'What does Kitxens do for Makondo?',
    what: [
      { icon: TrendingUp, t: 'More sales across all 6 locations', d: 'Live sales panel by location, dish and channel (dine-in, direct orders, DoorDash, catering). We detect what drives the ticket — weekend pan de bono to lunchtime bandeja paisa — and what to do each week to sell more.' },
      { icon: Search, t: 'Be found first', d: 'More and more guests ask Google and ChatGPT for "best Colombian food near me". We optimize your AI-search visibility, Google Business and reviews so Makondo shows up first in Westchester.' },
      { icon: Megaphone, t: 'Marketing that runs itself', d: 'Penny, our AI marketing director, prepares campaigns, content and promotions tailored to your kitchen and community. You just approve — nothing goes out without your OK.' },
      { icon: Star, t: 'Reputation protected', d: 'We monitor reviews across every location, catch issues before they escalate, and draft replies that sound like Makondo — not a robot.' },
      { icon: Building2, t: 'The 7th location, with data', d: 'When you decide to open the next restaurant, you will know: which area, which menu, which prices and what demand — with your 6 current locations as the proof model.' },
      { icon: ShieldCheck, t: 'VIP support', d: 'Direct line to our team. Monthly results review, a clear action plan, and an AI executive team working for you 24/7.' },
    ],
    teamTitle: 'Your AI executive team',
    teamSub: 'Six executives working for Makondo every day. They prepare everything; you decide.',
    team: [
      { k: 'rachel', n: 'Rachel', r: 'Coordinates the team' },
      { k: 'stan', n: 'Stan', r: 'Analyzes your sales' },
      { k: 'penny', n: 'Penny', r: 'Creates your marketing' },
      { k: 'sonny', n: 'Sonny', r: 'Distributes & publishes' },
      { k: 'eva', n: 'Eva', r: 'Guards operations' },
      { k: 'linda', n: 'Linda', r: 'Measures financial impact' },
    ],
    accessTitle: 'Your Restaurant AI OS access',
    accessSub: 'Your private workspace is ready — with your sales, your menu and your AI team. Sign in with the credentials we sent you by email.',
    accessEmail: 'Username',
    accessPwd: 'Password',
    accessPwdNote: 'sent by email · info@kitxens.com',
    accessBtn: 'Enter my Restaurant AI OS',
    accessHelp: 'Questions? Write to us at',
    ctaFoot: 'A little piece of Macondo, with the best sales copilot.',
  },
};

const MakondoNarration = ({ lang }) => {
  const [playing, setPlaying] = React.useState(false);
  const ref = React.useRef(null);
  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (playing) { a.pause(); setPlaying(false); }
    else { a.play(); setPlaying(true); }
  };
  return (
    <div className="mt-7 flex items-center gap-4" data-testid="makondo-narration">
      <audio ref={ref} src="/tenants/makondo-narracion.mp3" preload="none" onEnded={() => setPlaying(false)} />
      <button type="button" onClick={toggle} data-testid="makondo-narration-play"
        className="inline-flex items-center gap-2.5 rounded-full bg-[#F2B01E] hover:bg-[#d99c15] text-[#17130E] font-bold text-[13.5px] px-5 py-3 transition-colors">
        <span className="text-base">{playing ? '⏸' : '▶'}</span>
        {lang === 'es' ? (playing ? 'Pausar narración' : 'Escuchar la historia de Macondo') : (playing ? 'Pause narration' : 'Listen to the story of Macondo')}
      </button>
      <span className="text-[11.5px] text-white/40 italic max-w-[220px]">
        {lang === 'es' ? 'Narración en español, al estilo de los cuentos de Macondo · ~1 min' : 'Spanish narration, in the style of Macondo tales · ~1 min'}
      </span>
    </div>
  );
};

export default function MakondoWelcomePage() {
  const [lang, setLang] = useState('es');
  const t = T[lang];
  return (
    <div className="min-h-screen bg-[#17130E] text-[#F8F6F2]" data-testid="makondo-welcome-page">
      <SEO path="/makondo" title="Makondo Restaurants × Kitxens | VIP" noindex />
      <div className="max-w-[1080px] mx-auto px-5 sm:px-8 pt-24 md:pt-28 pb-20">
        <a href="https://kitxens.com" data-testid="makondo-back-link"
          className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-white/50 hover:text-white transition-colors mb-6">
          ← kitxens.com
        </a>
        {/* Hero */}
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4">
            <div className="rounded-2xl bg-white p-3 flex items-center gap-2.5">
              <img src="/tenants/makondo-logo-white.png" alt="Makondo Restaurants" className="h-11 w-auto" data-testid="makondo-logo" />
              <span className="text-[#17130E] font-bold leading-tight text-[15px]">Makondo<br /><span className="text-[10px] tracking-[0.22em] uppercase text-neutral-500 font-semibold">Restaurants</span></span>
            </div>
            <span className="text-2xl text-[#F2B01E] font-light">×</span>
            <img src="/kitxens-logo.png" alt="Kitxens" className="h-12 w-12 rounded-xl" />
          </div>
          <div className="flex items-center gap-2">
            <button type="button" onClick={() => setLang('es')} data-testid="makondo-lang-es"
              className={`px-3 py-1 rounded-full text-[12px] font-bold border transition-colors ${lang === 'es' ? 'bg-[#F2B01E] text-[#17130E] border-[#F2B01E]' : 'border-white/20 text-white/60 hover:text-white'}`}>ES</button>
            <button type="button" onClick={() => setLang('en')} data-testid="makondo-lang-en"
              className={`px-3 py-1 rounded-full text-[12px] font-bold border transition-colors ${lang === 'en' ? 'bg-[#F2B01E] text-[#17130E] border-[#F2B01E]' : 'border-white/20 text-white/60 hover:text-white'}`}>EN</button>
          </div>
        </div>

        <div className="mt-10">
          <div className="flex flex-wrap items-center gap-2.5">
            <p className="inline-flex items-center gap-2 rounded-full border border-[#F2B01E]/40 bg-[#F2B01E]/10 px-4 py-1.5 text-[11px] tracking-[0.22em] uppercase font-bold text-[#F2B01E]">
              <Crown className="w-3.5 h-3.5" /> {t.eyebrow}
            </p>
            <p className="inline-flex items-center gap-1.5 rounded-full bg-[#F2B01E] px-4 py-1.5 text-[11px] tracking-[0.18em] uppercase font-black text-[#17130E]" data-testid="makondo-star-badge">
              <Star className="w-3.5 h-3.5 fill-[#17130E]" /> {t.star}
            </p>
          </div>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">{t.title}</h1>
          <p className="mt-5 max-w-2xl text-base md:text-lg text-white/70 leading-relaxed">{t.sub}</p>
        </div>

        {/* Hero image */}
        <div className="mt-10 rounded-3xl overflow-hidden border border-white/10">
          <img src="/tenants/makondo-hero.jpg" alt="Bandeja paisa — Makondo Restaurants" className="w-full h-64 md:h-80 object-cover" />
        </div>

        {/* Macondo & García Márquez — the soul of the name */}
        <section className="mt-16 rounded-3xl border border-[#F2B01E]/25 bg-white/[0.03] p-8 md:p-10 relative overflow-hidden" data-testid="makondo-macondo-intro">
          <img src="/tenants/makondo-logo-white.png" alt="" aria-hidden className="absolute -right-6 -top-6 w-36 opacity-[0.07] rotate-12" />
          <p className="text-[11px] tracking-[0.24em] uppercase font-bold text-[#F2B01E]">
            {lang === 'es' ? '🦋 El alma del nombre · Macondo' : '🦋 The soul of the name · Macondo'}
          </p>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold leading-snug max-w-3xl" style={{ fontFamily: 'Georgia, serif' }}>
            {lang === 'es'
              ? '"Muchos años después…" — todo Macondo empieza con una promesa de memoria.'
              : '"Many years later…" — every Macondo begins with a promise of memory.'}
          </h2>
          <div className="mt-5 max-w-3xl space-y-4 text-[15px] leading-relaxed text-white/75" style={{ fontFamily: 'Georgia, serif' }}>
            {lang === 'es' ? (
              <>
                <p><b className="text-white">Macondo</b> es el pueblo imaginario que <b className="text-white">Gabriel García Márquez</b>, premio Nobel colombiano, creó como escenario de <i>Cien años de soledad</i>: el hogar mítico de la familia <b className="text-white">Buendía</b>, siete generaciones de triunfos, tragedias y soledades. El nombre lo vio de niño, en los viajes en tren, en el letrero de una finca bananera cerca de <b className="text-white">Aracataca</b>, su pueblo natal en el Magdalena.</p>
                <p>En sus calles nació el <b className="text-white">realismo mágico</b>: los fantasmas caminan con naturalidad, el tiempo se mueve en círculos, y las <b className="text-white">mariposas amarillas</b> 🦋 revolotean alrededor del amor verdadero, como las que seguían a Mauricio Babilonia. Todo alimentado por las historias sobrenaturales que sus abuelos le contaban de niño. Hoy Aracataca es un lugar de peregrinación literaria: los lectores viajan allí para ver el paisaje real que parió el pueblo imaginario más famoso de la literatura.</p>
                <p className="text-[#F2B01E]/90">Este restaurante lleva ese nombre con orgullo: un pedacito de Macondo en Nueva York, donde lo cotidiano — un pandebono recién horneado, una bandeja paisa humeante — también tiene algo de mágico.</p>
              </>
            ) : (
              <>
                <p><b className="text-white">Macondo</b> is the imaginary town that <b className="text-white">Gabriel García Márquez</b>, Colombia's Nobel laureate, created as the setting of <i>One Hundred Years of Solitude</i>: the mythical home of the <b className="text-white">Buendía</b> family — seven generations of triumphs, tragedies and solitudes. He saw the name as a child, on train rides, on the sign of a banana plantation near <b className="text-white">Aracataca</b>, his hometown in Magdalena.</p>
                <p>In its streets <b className="text-white">magical realism</b> was born: ghosts walk openly, time moves in loops, and <b className="text-white">yellow butterflies</b> 🦋 swarm around true love, like the ones that followed Mauricio Babilonia — all fed by the supernatural stories his grandparents told him as a boy. Today Aracataca is a literary landmark: readers travel there to see the real landscape that birthed literature's most famous imaginary town.</p>
                <p className="text-[#F2B01E]/90">This restaurant carries that name with pride: a little piece of Macondo in New York, where the everyday — a fresh pandebono, a steaming bandeja paisa — is also a little magical.</p>
              </>
            )}
          </div>
          <MakondoNarration lang={lang} />
        </section>

        {/* Locations */}
        <section className="mt-16">
          <h2 className="text-lg md:text-xl font-bold flex items-center gap-2"><MapPin className="w-5 h-5 text-[#F2B01E]" /> {t.locTitle}</h2>
          <p className="mt-2 text-[14px] text-white/60 max-w-2xl">{t.locSub}</p>
          <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {LOCATIONS.map((l) => (
              <div key={l.name} data-testid={`makondo-location-${l.name.toLowerCase().replace(' ', '-')}`}
                className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 hover:border-[#F2B01E]/50 transition-colors">
                <ChefHat className="w-5 h-5 text-[#F2B01E]" />
                <p className="mt-3 font-bold text-[15px]">{l.name}</p>
                <p className="mt-1 text-[12px] text-white/50 leading-relaxed">{l.addr}</p>
              </div>
            ))}
          </div>
        </section>

        {/* What we do */}
        <section className="mt-16">
          <h2 className="text-lg md:text-xl font-bold flex items-center gap-2"><BarChart3 className="w-5 h-5 text-[#F2B01E]" /> {t.whatTitle}</h2>
          <div className="mt-6 grid md:grid-cols-2 gap-4">
            {t.what.map((w) => (
              <div key={w.t} className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 hover:border-[#F2B01E]/50 transition-colors">
                <w.icon className="w-5 h-5 text-[#F2B01E]" />
                <p className="mt-3 font-bold text-[15.5px]">{w.t}</p>
                <p className="mt-2 text-[13px] text-white/60 leading-relaxed">{w.d}</p>
              </div>
            ))}
          </div>
        </section>

        {/* AI team */}
        <section className="mt-16">
          <h2 className="text-lg md:text-xl font-bold flex items-center gap-2"><Users className="w-5 h-5 text-[#F2B01E]" /> {t.teamTitle}</h2>
          <p className="mt-2 text-[14px] text-white/60">{t.teamSub}</p>
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {t.team.map((m) => (
              <div key={m.k} className="rounded-2xl border border-white/10 bg-white/[0.04] p-4 text-center">
                <img src={(TEAM_AVATARS.find((a) => a.key === m.k) || {}).img || `/avatars/${m.k}.png`} alt={m.n} className="w-14 h-14 rounded-full mx-auto object-cover" />
                <p className="mt-2.5 font-bold text-[13.5px] flex items-center justify-center gap-1">{m.n} <AgentHelp agent={m.k} isEs={lang === 'es'} dark /></p>
                <p className="mt-0.5 text-[11px] text-white/50 leading-snug">{m.r}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Access */}
        <section className="mt-16 rounded-3xl border border-[#F2B01E]/30 bg-gradient-to-b from-[#F2B01E]/10 to-transparent p-8 md:p-10" data-testid="makondo-access-card">
          <h2 className="text-xl md:text-2xl font-bold">{t.accessTitle}</h2>
          <p className="mt-2 text-[14px] text-white/65 max-w-xl">{t.accessSub}</p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <div className="rounded-xl bg-white/[0.06] border border-white/10 px-4 py-2.5">
              <p className="text-[10px] uppercase tracking-wider text-white/40 font-bold">{t.accessEmail}</p>
              <p className="text-[14px] font-mono font-bold text-white" data-testid="makondo-access-email">makondo@kitxens.com</p>
            </div>
            <div className="rounded-xl bg-white/[0.06] border border-white/10 px-4 py-2.5">
              <p className="text-[10px] uppercase tracking-wider text-white/40 font-bold">{t.accessPwd}</p>
              <p className="text-[14px] font-bold text-white/70">••••••••&nbsp; <span className="text-[11px] font-normal text-white/40">{t.accessPwdNote}</span></p>
            </div>
          </div>
          <Link to="/login" data-testid="makondo-login-btn"
            className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[#F2B01E] hover:bg-[#d99c15] text-[#17130E] font-bold text-[14.5px] px-6 py-3 transition-colors">
            {t.accessBtn} <ArrowRight className="w-4 h-4" />
          </Link>
          <p className="mt-5 text-[12.5px] text-white/45 flex items-center gap-1.5">
            <Mail className="w-3.5 h-3.5" /> {t.accessHelp} <a href="mailto:info@kitxens.com" className="text-[#F2B01E] hover:underline font-semibold">info@kitxens.com</a>
            <span className="mx-1 text-white/20">·</span>
            <span data-testid="makondo-host">{lang === 'es' ? 'Tu anfitrión de la demo: ' : 'Your demo host: '}<b className="text-white/80">Jorge Valencia</b></span>
          </p>
        </section>

        <p className="mt-12 text-center text-[13px] text-white/35 italic">🦋 {t.ctaFoot}</p>
      </div>
    </div>
  );
}
